define('PartApplication.PDP.View',
	[
		'part_application_pdp.tpl',
		'SCView'
	],
	function (
		part_application_pdp_tpl,
		SCViewComponent
	) {
		'use strict'

		var SCView = SCViewComponent.SCView;

		function PartApplicationPDPView(options) {
			SCView.call(this);

			this.options = options || {};

			this.template = part_application_pdp_tpl;

			this.initialize = function initialize(options) {
				this.container = options.container;
				this.model = options.model;
				this.vehicleData = options.vehicleData;
				if(this.vehicleData && this.vehicleData.year && this.vehicleData.make && this.vehicleData.model){
					this.vehicle = this.vehicleData.year + ' ' + this.vehicleData.make + ' ' + this.vehicleData.model;
				}
				this.pdp = this.container.getComponent('PDP');
				this.itemInfo = this.pdp.getItemInfo();

				var self = this;

				if(this.itemInfo){
					if(this.vehicleData.year && this.vehicleData.make && this.vehicleData.model){
						var self = this;
						self.model.fetch({
							data: {
								year: self.vehicleData.year,
								make: self.vehicleData.make,
								model: self.vehicleData.model,
								itemId: self.itemInfo.item.internalid
							}
						}).done(function (result) {
							self.info = _.find(result.result,function(res){
								return res.itemId == self.itemInfo.item.internalid
							});
							if(self.info && self.vehicle && self.info.location && self.info.partApplicationId){
								self.pdp.setOption('custcol_rp_vehicle', self.formatForUrl(self.vehicle));
								self.pdp.setOption('custcol_rp_part_location', self.info.location);
								self.pdp.setOption('custcol_rp_part_application', self.info.partApplicationId);
								self.render();
							}
						});
					}
				}
			}

			this.initialize(options);

			this.formatForUrl = function(text){
				var textToFormat = text;
				var replaceableCharacters = [
					{character: '-', encodedValue: '~'},
					{character: '/', encodedValue: '-SLASH-'},
					{character: '&(?!amp;)', encodedValue: '-AND-'},
					{character: ',', encodedValue: '%2C'},
					{character: "'", encodedValue: '%27'},
					{character: ' ', encodedValue: '-'}
				];

				_.each(replaceableCharacters, function(replaceableCharacter){
					var expression = new RegExp(replaceableCharacter.character, "g");
					textToFormat = textToFormat.replace(expression, replaceableCharacter.encodedValue);
				});

				return textToFormat;
			}
		}

		PartApplicationPDPView.prototype = Object.create(SCView.prototype);

		PartApplicationPDPView.prototype.constructor = PartApplicationPDPView;

		PartApplicationPDPView.prototype.getContext = function getContext() {
			return {
				haveVehicle: !!this.vehicle,
				vehicle: this.vehicle,
				haveLocation: !!this.info,
				location: this.info ? this.info.location : ''
			};
		}
		return PartApplicationPDPView;
	}
);
